import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenToolbarFile } from '#/entities/shipment'
import type { ShipmentFileFeedItem } from '#/entities/shipment'
import { FileIcon } from '#/shared/ui/icons'
import { HistoryRow, HistoryViewLink } from '#/shared/ui/history-row'
import { formatBytes } from '#/shared/lib/format'

function fileMeta(file: ShipmentFileFeedItem): React.ReactNode[] {
  const meta: React.ReactNode[] = []
  if (file.timestamp) meta.push(file.timestamp)
  if (file.authorName) meta.push(file.authorName)
  const size = formatBytes(file.sizeBytes)
  if (size) meta.push(size)
  return meta
}

function FileViewAction({
  fileId,
  onOpen,
}: {
  fileId: string
  onOpen: (fileId: string) => void
}) {
  const { t } = useTranslation()
  return (
    <HistoryViewLink onClick={() => onOpen(fileId)}>
      {t('orderDetails.history.actions.view')}
    </HistoryViewLink>
  )
}

export function FileHistoryRow({ file }: { file: ShipmentFileFeedItem }) {
  const openFile = useOpenToolbarFile()
  return (
    <HistoryRow
      icon={FileIcon}
      title={file.name}
      meta={fileMeta(file)}
      action={<FileViewAction fileId={file.id} onOpen={openFile} />}
    />
  )
}
